export default {
  SET_STATE: (state, payload) => {
    state[payload.action] = payload.data
  },
  SET_EXPENSE_CATEGORY: (state, list) => {
    state.expense_category = list
  },
  SET_LOADING: (state, status) => {
    state.loading = status
  }
}
